import styled from 'styled-components';
import { applyTrackingId } from '../../../AnalyticsContext/applyTrackingId';
import { renderLinkTrackingAttributes } from '../../../AnalyticsContext/renderLinkTrackingAttributes';
import { PropsOf } from '../../../util/PropsOf';
import { Link } from '../../Link';
import {
  ButtonStyleProps,
  constantButtonStyles,
  getBackgroundColor,
  getBorderStyle,
  getTextColor,
  getSizing,
} from '../Button.styles';
import { ButtonCompartments } from '../ButtonCompartments';
import { ButtonProps } from '../constants';

const ButtonView = styled(Link)<ButtonStyleProps>`
  ${constantButtonStyles};
  ${getBorderStyle};
  ${getTextColor};
  ${getBackgroundColor};
  ${getSizing}
`;

export const LinkButton = ({
  leftContent,
  children,
  rightContent,
  trackingData: clickTracking,
  trackingId,
  ...viewProps
}: ButtonProps & PropsOf<typeof ButtonView>) => {
  const clickTrackingAttributes = renderLinkTrackingAttributes(clickTracking);
  const trackingIdProps = applyTrackingId(trackingId);

  return (
    <ButtonView {...viewProps} {...clickTrackingAttributes} {...trackingIdProps}>
      <ButtonCompartments
        leftContent={leftContent}
        rightContent={rightContent}
        options={viewProps.options}
      >
        {children}
      </ButtonCompartments>
    </ButtonView>
  );
};
